/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import styled from 'styled-components';

export const overflow = styled.div`
  @media (max-width: 768px) {
    overflow-x: auto;
    overflow-y: auto;
  }
`;
export const mainHeading = styled.div`
  font-size: 16px;
  font-weight: bold;
`;

export const Text = styled.div`
  font-size: 14px;
`;
export const PolicyHead = styled.div`
  font-size: 16px;
  font-weight: bold;
  text-align: center;
`;
export const Policy = styled.div`
  font-size: 14px;
  text-align: center;
`;
export const paymentHeader = styled.div`
  font-size: 14px;
  text-align: left;
  font-weight: bold;
`;
export const paymentSubHeader = styled.div`
  font-size: 14px;
  text-align: left;
`;

export const Border = styled.div`
  @media (max-width: 768px) {
    border-bottom: 0px;
    border-right: 1px solid;
    padding-right: 20px;
  }
  border-bottom: 1px solid;
  padding: 10px;
  font-size: 14px;
`;
export const BorderItem = styled.div`
  @media (max-width: 768px) {
    padding-left: 10px;
  }
  font-weight: bold;
  font-size: 16px;
  padding: 10px;
`;
